export function formatAnalysisCalendarButtonLabel(
  selectedTimeRange: string,
  appliedStartDate: Date | null,
  appliedEndDate: Date | null,
  startDate: Date | null,
  endDate: Date | null
): string {
  if (selectedTimeRange !== 'Custom date range') {
    return selectedTimeRange;
  }

  const rangeStart = appliedStartDate && appliedEndDate ? appliedStartDate : startDate;
  const rangeEnd = appliedStartDate && appliedEndDate ? appliedEndDate : endDate;
  if (!rangeStart || !rangeEnd) {
    return 'Select date range';
  }

  const formatPart = (date: Date) =>
    `${date.toLocaleDateString()} ${date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
  return `${formatPart(rangeStart)} - ${formatPart(rangeEnd)}`;
}

const PREDEFINED_TIME_RANGES = [
  { label: 'Last 1 hour', hours: 1 },
  { label: 'Last 2 hours', hours: 2 },
  { label: 'Last 4 hours', hours: 4 },
  { label: 'Last 8 hours', hours: 8 },
  { label: 'Last 24 hours', hours: 24 },
  { label: 'Last 7 days', hours: 7 * 24 },
];

export function matchPredefinedTimeRangeLabel(start: Date, end: Date): string | null {
  const now = new Date();
  for (const range of PREDEFINED_TIME_RANGES) {
    const expectedStart = new Date(now.getTime() - range.hours * 60 * 60 * 1000);
    const expectedEnd = new Date(now);
    const timeDiffStart = Math.abs(start.getTime() - expectedStart.getTime());
    const timeDiffEnd = Math.abs(end.getTime() - expectedEnd.getTime());
    if (timeDiffStart < 5 * 60 * 1000 && timeDiffEnd < 5 * 60 * 1000) {
      return range.label;
    }
  }
  return null;
}

export function shouldShowGroupChartEmptyState(
  initialDataLoadComplete: boolean,
  hasNoData: boolean,
  chartDataLoading: boolean,
  chartCreated: boolean,
  hasValidChartData: boolean,
  chartDataSnapshotLength: number
): boolean {
  return initialDataLoadComplete
    && hasNoData
    && !chartDataLoading
    && !chartCreated
    && !hasValidChartData
    && chartDataSnapshotLength === 0;
}

export function canExportAnalysisData(selectedSensorCount: number, isExporting: boolean): boolean {
  return selectedSensorCount > 0 && !isExporting;
}
